import { UPDATE_TEXT_ONLY_FIELD_VALUE } from '@/store/modules/ProposalContext';
import store from '@/store/store';
import { Options, Vue } from 'vue-class-component';

@Options({
	name: 'TextOnlyFieldComponent',
	components: {},
	props: {
		tooltip: String,
		htmlValue: String,
		fieldId: String,
	},
})
export default class TextOnlyFieldComponent extends Vue {
	tooltip: string;
	htmlValue: string;
	fieldId: string;

	public id: string;
	public value: string;
	public dynamicTooltip: boolean;
	public refreshKey: string = '_';

	public created() {
		store.subscribeAction((action, state) => {
			if (action.type === UPDATE_TEXT_ONLY_FIELD_VALUE) {
				if (action.payload.id === this.fieldId) {
					this.value = action.payload.value;
					this.refreshKey += 1;
				}
			}
		});
	}
	public beforeMount() {
		this.id = '_' + Math.floor(Math.random() * 1000000);

		// if there is an override value for this field in the store, use it instead of the default htmlValue
		if (store.state.ProposalContext.textOnlyFieldOverrides.has(this.fieldId)) {
			this.value = store.state.ProposalContext.textOnlyFieldOverrides.get(this.fieldId);
			return;
		}
		this.dynamicTooltip = this.tooltip && this.htmlValue?.toLocaleLowerCase()?.includes('{{tooltip}}');
		if (this.dynamicTooltip) {
			this.value = this.htmlValue.replaceAll(/{{tooltip}}/gi, '<span class="tooltip-temp hide"></span>');
		} else {
			this.value = this.htmlValue;
		}
	}

	public mounted() {
		if (this.dynamicTooltip) {
			const me = document.getElementById(this.id).querySelector('span.tooltip-temp');
			const pop = document.getElementById(this.id).querySelector('.dynamic-position');
			me.appendChild(pop);
			me.classList.toggle('hide');
		}
	}
}
